import { TranslationKeys } from '@/localization';
import { Listbox } from '@headlessui/react';
import { ComponentProps, FunctionComponent, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { SelectFooter } from './SelectFooter/SelectFooter';
import { SelectInput } from './SelectInput';
import { SelectLabel } from './SelectLabel/SelectLabel';
import { SelectOptionsList } from './SelectOptionsList';
import { SelectOption } from './types';

type SelectProps = {
  items: SelectOption[];
  value: SelectOption | null;
  onChange: (item: SelectOption) => void;
  labelProps?: ComponentProps<typeof SelectLabel>;
  placeholder?: string;
  placeholderImage?: ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  error?: string;
  hint?: TranslationKeys;
  classNames?: {
    wrapper?: string;
    trigger?: string;
    optionsWrapper?: string;
    hintClassName?: string;
    footer?: ComponentProps<typeof SelectFooter>['classNames'];
  };
};

export const Select: FunctionComponent<SelectProps> = ({
  items,
  value,
  onChange,
  labelProps,
  placeholder,
  placeholderImage,
  disabled,
  isLoading,
  error,
  hint,
  classNames,
}) => {
  return (
    <Listbox value={value} onChange={onChange} disabled={disabled || isLoading} by={(a, b) => a?.id === b?.id}>
      {({ open }) => (
        <div className={twMerge('space-y-1.5 min-w-60', classNames?.wrapper)}>
          {labelProps && <SelectLabel {...labelProps} />}
          <div className='relative'>
            <SelectInput
              value={value}
              className={classNames?.trigger}
              isLoading={isLoading}
              placeholder={placeholder}
              placeholderImage={placeholderImage}
              error={error}
            />
            <SelectOptionsList
              items={items}
              open={open}
              classNames={{
                wrapper: classNames?.optionsWrapper,
              }}
            />
          </div>
          <SelectFooter error={error} hint={hint} classNames={classNames?.footer} />
        </div>
      )}
    </Listbox>
  );
};
